import Model from "./base/model";

class Helper extends Model{
  resourceName() {
    return "helpers";
  }

  fields() {
    return {
      name: "",
      cpf: "",
      transporter: { jsonApi: "hasOne", type: "transporters"},
    };
  }
}

export default new Helper();
